// Utility for syncing dataTypesShared on assets when assets/suppliers are linked/unlinked in DataRetentionDialog
import { getAssets, updateAsset } from '@/services/assetsService';

/**
 * Syncs the dataTypesShared array on all affected assets.
 * Adds or removes the given dataTypeID (not name!) from each asset's dataTypesShared.
 *
 * @param assetIds Array of asset IDs to update
 * @param dataTypeID ID of the data type to add/remove
 * @param add If true, add; if false, remove
 */
import { getAsset, updateAsset } from '@/services/assetsService';

export async function syncAssetsDataTypesShared(assetIds: string[], dataTypeID: string | number, add: boolean) {
  const idStr = String(dataTypeID);
  for (const assetId of assetIds) {
    const asset = await getAsset(assetId);
    if (!asset || !asset.entity) continue;
    let shared = Array.isArray(asset.entity.dataTypesShared) ? [...asset.entity.dataTypesShared] : [];
    shared = shared.map(dt => String(dt)); // ensure all are strings for comparison
    if (add) {
      if (!shared.includes(idStr)) shared.push(idStr);
    } else {
      shared = shared.filter(dt => dt !== idStr);
    }
    await updateAsset(String(asset.entity.assetID), { dataTypesShared: shared });
  }
}
